import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { SiteHeader } from '@/components/site-header'
import { PATHROUTES } from '@/constants/path'
import DemographicsData from '@/components/sponsorship/DemographicsData'
import { SponsorAdStatistics } from '@/components/sponsorship/SponsorAdStatistics'
import { useUnreadMessages } from '@/hooks/useUnreadMessages'
import { tokenService } from '@/lib/token.service'
import ChatIconWithCount from '@/components/chat/ChatIconWIthCount'

export default function Demographics() {
  const [searchQuery, setSearchQuery] = useState('')
  const navigate = useNavigate()
  const user = tokenService.getUser()
  const { unreadCount } = useUnreadMessages(user.id)

  const handleSearchChange = (value: string) => {
    setSearchQuery(value)
  }

  const handleMessageAdminClick = () => {
    navigate(PATHROUTES.DASHBOARD.MESSAGE_ADMIN)
  }

  return (
    <main
      className="@container/main flex flex-1 flex-col relative"
      id="main-content"
      tabIndex={-1}
      aria-label="Demographics Dashboard Main Content"
    >
      <section
        aria-label="Event Management Header and Actions"
        className="flex flex-col gap-2 mb-6"
      >
        <SiteHeader
          title="Demographics"
          subtitle="Anonymized demographic insights of users engaging with your advertisements"
          searchPlaceholder="Search"
          onSearchChange={handleSearchChange}
          searchValue={searchQuery}
          showSearch={true}
        />

        <SponsorAdStatistics />
      </section>

      {/* Demographics Data Component */}
      <div className="px-4 lg:px-6">
        <DemographicsData />
      </div>

      {/* Floating Action Button */}
      <ChatIconWithCount
        count={unreadCount}
        handleClick={handleMessageAdminClick}
      />
    </main>
  )
}
